import React from 'react';
const methods = ['VISA', 'Mastercard', 'AMEX', 'Mercado Pago'];
export function PaymentLogos() {
  return <ul className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-138" data-mp="3ov9rc7y4iifg">
      {methods.map(method => <li key={method} className="rounded-lg border border-plum/15 bg-white px-3.5 py-2 font-sans text-xs font-black uppercase tracking-wider text-plum/70" data-id="element-139" data-mp="7cytnt2zv4i9">
          {method}
        </li>)}
    </ul>;
}